export default __webpack_public_path__ + "static/media/graph.8f78b8bb.png";